<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid fill-height class="indigo lighten-4 mr-1 ml-0">
    <v-layout align-center justify-center :column="windowSize.x < 600">
      <br/>
        <v-flex mr-2 ml-2 xs12 sm8 md4>
          <v-form @submit.prevent="submitForm(form)">
            <v-card class="elevation-12 mx-auto">
              <v-toolbar dark color="primary lighten-1">
                <v-toolbar-title class="font-weight-bold">Cetak Slip Gaji MDKGU</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model="form.year"
                  label="Tahun"
                  placeholder="YYYY"
                  hint="Format: YYYY"
                  persistent-hint
                ></v-text-field>
                <br/>

                <v-text-field
                  v-model="form.month"
                  label="Bulan"
                  placeholder="MM"
                  hint="Format: 01 - 12"
                  persistent-hint
                ></v-text-field>
                <br/>

                <v-text-field
                  v-model="form.ic_number"
                  :counter="12"
                  label="No. Kad Pengenalan"
                  hint="Format: No Kad Pengenalan tanpa '-'"
                  persistent-hint
                ></v-text-field>
                <br/>

                <v-text-field
                  v-model="form.password"
                  label="Kata Laluan"
                  type="password"
                ></v-text-field>

              </v-card-text>
              <v-card-actions class="ma-2 pb-4">
                <v-btn @click.native="$router.push('/payslip/reset')" color="error lighten-1">
                  Set Kata Laluan
                </v-btn>
                <v-spacer v-if="windowSize.x > 600"></v-spacer>
                <v-btn color="primary lighten-1" type="submit">
                  Muat turun PDF
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
        <v-card class="ml-4 mr-4 transparent elevation-0">
          <img pa-2 :width="windowSize.x < 600 ? 200 : 300" src="img/undraw_team.svg">
        </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import configuration from '../../configurations'

export default {
  data () {
    return {
      loading: false,
      windowSize: {
        x: 0,
        y: 0
      },
      form: {
        year: '',
        month: '',
        ic_number: '',
        password: ''
      }
    }
  },
  mounted () {
    this.onResize()
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    async submitForm (form) {
      this.loading = true

      const errorCode = {
        ic_number: 'Sila isi No Kad Pengenalan dengan betul',
        year: 'Sila isi Tahun dengan betul, Contoh: 2022',
        month: 'Sila isi Bulan dengan betul, Contoh: 06'
      }

      if (form.ic_number.length !== 12) {
        return this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: errorCode['ic_number' || 400],
          visible: true
        })
      }

      if (form.year.length !== 4) {
        return this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: errorCode['year' || 400],
          visible: true
        })
      }

      if (form.month.length !== 2) {
        return this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: errorCode['month' || 400],
          visible: true
        })
      }

      try {
        const { data, statusText } = await axios.post(
          `${configuration.host.EPBT3}/_payroll/printPayslip`,
          form,
          { responseType: 'blob' }
        )
        if (statusText && statusText === 'OK' && data) {
          const blob = data
          const anchor = document.createElement('a')
          anchor.href = await URL.createObjectURL(blob)
          anchor.download = `MDKGU_SlipGaji${
            form.ic_number
          }_${form.year}${form.month}`
          document.body.appendChild(anchor)
          anchor.click()
          anchor.remove()
        }
      } catch (error) {
        const errorCode = {
          401: 'Oops! Your Password and IC Number does not match.',
          403: `Oops! Your payslip for ${form.year}-${form.month} is not ready.`,
          404: `Oops! Your payslip for ${form.year}-${form.month} is not found.`,
          400: 'Internal Server Error'
        }
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: errorCode[error.message.slice('-3') || 400],
          visible: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
